import axios from 'axios';

const baseURL = process.env.REACT_APP_API_BASE_URL;

axios.defaults.baseURL = baseURL;
axios.defaults.withCredentials = true;
